import React, {useEffect} from 'react';
import {Container} from './SubmissionError.styles';

const SubmissionError = ({title, errors}) => {
  return (
    <Container>
      {title && <h4>{title}</h4>}
      {errors && errors.length > 0 && (
        <ul>
          {errors.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      )}
    </Container>
  );
};

export default SubmissionError;
